import { render, staticRenderFns } from "./AGDataTable.vue?vue&type=template&id=af069724"
import script from "./AG-data-table.js?vue&type=script&lang=js&external"
export * from "./AG-data-table.js?vue&type=script&lang=js&external"
import style0 from "./AG-data-table.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports